import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const categoryGroups = [
  {
    title: 'Fashion & Apparel',
    items: [
      { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
      { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
      { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
      { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-user-3-line' },
      { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-checkbox-blank-line' },
      { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-basketball-line' },
    ],
  },
  {
    title: 'Accessories & More',
    items: [
      { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-smile-line' },
      { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
      { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-vip-diamond-line' },
      { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-briefcase-line' },
      { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-links-line' },
      { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
      { name: 'Underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-check-line' },
      { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
    ],
  },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoriesExpanded, setCategoriesExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      setCategoriesExpanded(false);
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950 tracking-tight">
              Hipobuy <span className="text-accent-500">Spreadsheet</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <a href="#categories" className="text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
              Categories
            </a>
            <a href="#about" className="text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
              About
            </a>
            <a href="#trending" className="text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
              Trending
            </a>
            <Link to="/article/hipobuy-spreadsheet-guide" className="text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
              Guides
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Visit Main Store
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden fixed top-16 left-0 right-0 bottom-0 bg-background-50 overflow-y-auto z-40">
          <div className="px-4 py-4 flex flex-col gap-4">

            <div className="flex flex-col gap-1.5">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-5 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
                onClick={() => setMobileOpen(false)}
              >
                Visit Main Store
                <i className="ri-arrow-right-up-line text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-5 py-3 border-2 border-foreground-200 text-foreground-700 rounded-full text-sm font-semibold hover:border-foreground-400 transition-colors whitespace-nowrap"
                onClick={() => setMobileOpen(false)}
              >
                Buy It Now
                <i className="ri-shopping-bag-line text-sm"></i>
              </a>
            </div>

            <div className="h-px bg-background-200"></div>

            <a href="#categories" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 py-2 transition-colors" onClick={() => setMobileOpen(false)}>
              <i className="ri-grid-line mr-2"></i> Browse Categories
            </a>
            <a href="#about" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 py-2 transition-colors" onClick={() => setMobileOpen(false)}>
              <i className="ri-information-line mr-2"></i> About Spreadsheet
            </a>
            <a href="#trending" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 py-2 transition-colors" onClick={() => setMobileOpen(false)}>
              <i className="ri-fire-line mr-2"></i> Trending
            </a>

            <button
              onClick={() => setCategoriesExpanded(!categoriesExpanded)}
              className="flex items-center justify-between text-sm font-medium text-foreground-700 hover:text-foreground-950 py-2 transition-colors"
            >
              <span>
                <i className="ri-price-tag-3-line mr-2"></i> All Categories
              </span>
              {categoriesExpanded ? (<i className="ri-arrow-up-s-line text-sm"></i>) : (<i className="ri-arrow-down-s-line text-sm"></i>)}
            </button>

            {categoriesExpanded && (
              <div className="flex flex-col gap-4 pl-2">
                {categoryGroups.map((group) => (
                  <div key={group.title}>
                    <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-2 px-2">
                      {group.title}
                    </p>
                    <div className="grid grid-cols-2 gap-1">
                      {group.items.map((cat) => (
                        <a
                          key={cat.name}
                          href={cat.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="flex items-center gap-2 px-2 py-2.5 rounded-lg text-sm text-foreground-600 hover:bg-accent-50 hover:text-accent-700 transition-colors"
                          onClick={() => setMobileOpen(false)}
                        >
                          <span className="w-7 h-7 flex items-center justify-center rounded-md bg-background-100 text-foreground-500 flex-shrink-0">
                            <i className={`${cat.icon} text-xs`}></i>
                          </span>
                          <span className="whitespace-nowrap text-xs">{cat.name}</span>
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="h-px bg-background-200"></div>

            <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider">SEO Guides</p>
            <Link to="/article/hipobuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 py-1.5 transition-colors" onClick={() => setMobileOpen(false)}>
              Hipobuy Spreadsheet Guide
            </Link>
            <Link to="/article/kakobuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 py-1.5 transition-colors" onClick={() => setMobileOpen(false)}>
              Kakobuy Spreadsheet Guide
            </Link>
            <Link to="/article/cssbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 py-1.5 transition-colors" onClick={() => setMobileOpen(false)}>
              CSSBuy Spreadsheet Guide
            </Link>
            <Link to="/article/superbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 py-1.5 transition-colors" onClick={() => setMobileOpen(false)}>
              Superbuy Spreadsheet Guide
            </Link>
            <Link to="/article/oopbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 py-1.5 transition-colors" onClick={() => setMobileOpen(false)}>
              Oopbuy Spreadsheet Guide
            </Link>

            <div className="h-px bg-background-200"></div>

            <div className="flex flex-wrap gap-2 pb-6">
              <span className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-check-line text-accent-500 text-xs"></i> Updated Resources
              </span>
              <span className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-check-line text-accent-500 text-xs"></i> Organized Categories
              </span>
              <span className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-check-line text-accent-500 text-xs"></i> Safety Verified
              </span>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}